import React from 'react';

import { CheckOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useIntl } from 'react-intl';

import styles from './styles.module.less';

interface ApplyReportFiltersButtonProps {
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
}

const ApplyReportFiltersButton: React.FC<ApplyReportFiltersButtonProps> = ({
  onClick,
  disabled,
  loading,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Button
        block
        type="primary"
        icon={<CheckOutlined />}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
      >
        {intl.formatMessage({ id: 'button.apply.filters' })}
      </Button>
    </div>
  );
};

export default ApplyReportFiltersButton;
